"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancelOrder = exports.cancelOrderWithConnection = void 0;
const spl_token_1 = require("@solana/spl-token");
const web3_js_1 = require("@solana/web3.js");
const state_1 = require("../state");
const util_1 = require("../util");
const createOpenOrdersCounter_1 = require("./createOpenOrdersCounter");
/**
 * Cancels Order with Solana connection
 * Takes a connection to fetch necessary accounts - it is preferred to use `cancelAccount`
 * if account data can be provided without an RPC connection.
 * @param connection - Connection
 * @param orderInitializer - Order Initializer Key
 * @param orderAccount - Order Account
 * @param program - Galactic Marketplace Program
 * @returns InstructionReturn
 */
function cancelOrderWithConnection(connection, orderInitializer, orderAccount, program) {
    return __awaiter(this, void 0, void 0, function* () {
        const instructionArray = [];
        const orderAccountInfo = orderAccount.data;
        const orderSide = (0, util_1.getOrderSide)(orderAccount);
        const depositMint = orderSide === 'SellSide'
            ? orderAccountInfo.assetMint
            : orderAccountInfo.currencyMint;
        // Get initializer deposit token account, pushing creation instruction if necessary
        let initializerDepositTokenAccount;
        const response = yield (0, util_1.getTokenAccount)(connection, orderInitializer, depositMint);
        const tokenAccount = response.tokenAccount;
        if ('createInstruction' in response) {
            instructionArray.push(response.createInstruction);
        }
        if (tokenAccount instanceof web3_js_1.Keypair) {
            initializerDepositTokenAccount = tokenAccount.publicKey;
        }
        else {
            initializerDepositTokenAccount = tokenAccount;
        }
        // Get open orders counter, pushing creation instruction if necessary
        const [openOrdersCounterAddress] = state_1.OpenOrdersCounter.findAddress(program, orderInitializer, depositMint);
        const orderCounter = yield connection.getAccountInfo(openOrdersCounterAddress);
        if (orderCounter === null) {
            const createOpenOrderCounterInstruction = yield (0, createOpenOrdersCounter_1.createOpenOrdersCounter)(program, orderInitializer, depositMint);
            instructionArray.push(createOpenOrderCounterInstruction);
        }
        const cancelInstruction = cancelOrder(program, orderAccount, orderInitializer, { key: initializerDepositTokenAccount }, { key: openOrdersCounterAddress });
        instructionArray.push(cancelInstruction);
        return instructionArray;
    });
}
exports.cancelOrderWithConnection = cancelOrderWithConnection;
/**
 * Cancels Order
 * @param program -Galactic Marketplace Program
 * @param orderAccount - Order Account
 * @param orderInitializer - Order Initializer Key
 * @param initializerDepositTokenAccount - Deposit Token Account
 * @param openOrdersCounter - OpenOrdersCounter Account/Key
 * @returns InstructionReturn
 */
function cancelOrder(program, orderAccount, orderInitializer, initializerDepositTokenAccount, openOrdersCounter) {
    // Pass in order account and fetch data or pass in `Order`?
    const orderAccountInfo = orderAccount.data;
    const orderSide = (0, util_1.getOrderSide)(orderAccount);
    const depositMint = orderSide === 'SellSide'
        ? orderAccountInfo.assetMint
        : orderAccountInfo.currencyMint;
    const [orderVaultAccount] = state_1.Order.getOrderVaultAddress(program, orderInitializer, depositMint);
    const [orderVaultAuthority] = state_1.Order.getOrderVaultAuthorityAddress(program, orderInitializer);
    // Fetch token account with `getTokenAccount`?
    return (funder) => __awaiter(this, void 0, void 0, function* () {
        return ({
            instruction: yield program.methods
                .processCancel()
                .accountsStrict({
                marketVarsAccount: state_1.MarketVars.findAddress(program)[0],
                signer: funder.publicKey(),
                orderInitializer,
                depositMint,
                initializerDepositTokenAccount: 'key' in initializerDepositTokenAccount
                    ? initializerDepositTokenAccount.key
                    : initializerDepositTokenAccount.account.address,
                orderVaultAccount,
                orderVaultAuthority,
                orderAccount: orderAccount.key,
                openOrdersCounter: 'key' in openOrdersCounter
                    ? openOrdersCounter.key
                    : openOrdersCounter.openOrdersCounter.key,
                tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
            })
                .instruction(),
            signers: [funder],
        });
    });
}
exports.cancelOrder = cancelOrder;
//# sourceMappingURL=cancelOrder.js.map